import styled from 'styled-components';

export const Wrapper = styled.div`
    margin: 10px 0;
    background: linear-gradient(161.3deg, #fff7e5 -2.04%, #fbe9f6 102.81%);
    border-radius: 12px;
    padding: 16px;
    display: flex;
    align-items: center;
`;

export const IconWrapper = styled.div`
    margin: 5px;
`;

export const LoaderWrapper = styled.div`
    width: 20px;
    height: 20px;
`;

export const TextBoxWrapper = styled.div`
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 15px;
`;

export const Text = styled.h2`
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #000000;
    margin: 4px;
`;
